import routes from '@modules/location/location-routes';
import store from '@modules/location/location-store';

export default {
  routes,
  store,
};
